import React from "react";
import '../css/HomePage.css'; // Import the CSS file

const HomePage = () => {
  return (
    <div className="home-page">
      {/* Hero Section */}
      <div className="hero-section">
        <h1>Empowering Financial Professionals</h1>
        <p>
          Simplify your workflows, optimize client management, and stay ahead in the financial services industry
        </p>
      </div>

      {/* Visual Section */}
      <div className="visual-section">
        <img src="/app/images/LandingPage.png" alt="Financial Services Visualization" />
      </div>

      {/* Footer */}
      <footer className="footer">
        <p>Start transforming your financial practice today</p>
        <button>Sign Up for Free</button>
      </footer>
    </div>
  );
};

export default HomePage;